import { format } from 'date-fns';
interface Props {
  legInfo: any;
  leg: string;
  travellingFrom: string;
  travellingTo: string;
}
function PickUpInfoLeg({ legInfo, leg, travellingFrom, travellingTo }: Props) {
  let transtTime =
    legInfo?.transit_days === -1
      ? 'N/A'
      : legInfo?.transit_days === 1 || legInfo?.transit_days === 0
      ? 'Same Day'
      : `${legInfo?.transit_days} Days`;

  let estDeliveryDate = legInfo?.delivery_date;
  return (
    <>
      <tr>
        <td className='align-middle'>{legInfo?.routing?.carrier_name}</td>
        <td className='align-middle'>
          Traveling from{' '}
          <span id={`${leg}_travelling_from`}>{travellingFrom}</span> to{' '}
          <span id={`${leg}_travelling_to`}>{travellingTo}</span>
        </td>
        <td className='align-middle'>{transtTime}</td>
        <td className='align-middle'>
          {format(new Date(estDeliveryDate), 'yyyy-MM-dd HH:mm')}
        </td>
      </tr>
    </>
  );
}

export default PickUpInfoLeg;
